import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";

import {
  DEBRIEF_EMAIL_PENDING,
  GET_DEBRIEF_EMAIL,
  SG_GET_DEBRIEF_EMAIL,
  ADD_DEBRIEF_EMAIL,
  SG_ADD_DEBRIEF_EMAIL,
  DELETE_DEBRIEF_EMAIL,
  SG_DELETE_DEBRIEF_EMAIL,
  UPDATE_DEBRIEF_EMAIL,
  SG_UPDATE_DEBRIEF_EMAIL,
  FETCH_DEBRIEF_EMAIL,
  SG_FETCH_DEBRIEF_EMAIL,
  ALL_ERRORS,
} from "constants/actions";



function* loadmethods(action) {
    yield put({ type: DEBRIEF_EMAIL_PENDING });
  
  try {
    const json = yield call(api.GET_DEBRIEF_EMAILS, action.payload);
    yield put({ type: GET_DEBRIEF_EMAIL, payload: json.data });

  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodLoad() {
  yield takeLatest(SG_GET_DEBRIEF_EMAIL, loadmethods);
}

function* fetchmethods(action) {
  yield put({ type: DEBRIEF_EMAIL_PENDING });
  try {
    const json = yield call(api.FETCH_DEBRIEF_EMAIL, action.payload);
    yield put({ type: FETCH_DEBRIEF_EMAIL, payload: json.data });

  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_DEBRIEF_EMAIL, fetchmethods);
}

function* updatemethods(action) {
  yield put({ type: DEBRIEF_EMAIL_PENDING });
  try {
    const json = yield call(api.EDIT_DEBRIEF_EMAIL, action.payload);
    yield put({ type: UPDATE_DEBRIEF_EMAIL, payload: json.data });

  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodUpdate() {
  yield takeLatest(SG_UPDATE_DEBRIEF_EMAIL, updatemethods);
}

function* addmethods(action) {
  yield put({ type: DEBRIEF_EMAIL_PENDING });
  try {
    const json = yield call(api.ADD_DEBRIEF_EMAIL, action.payload);
    yield put({ type: ADD_DEBRIEF_EMAIL, payload: json.data });

  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_DEBRIEF_EMAIL, addmethods);
}

function* deletemethods(action) {
  yield put({ type: DEBRIEF_EMAIL_PENDING });
  try {
    yield call(api.DELETE_DEBRIEF_EMAIL, action.payload);
    yield put({ type: DELETE_DEBRIEF_EMAIL, payload: action.payload });

  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_DEBRIEF_EMAIL, deletemethods);
}


export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
